export default __webpack_public_path__ + "static/media/search-icon-white.ab068151.svg";